import { BrandingResponse } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchBranding = async (signal) => BrandingResponse.parse(await request('/api/v1/organization/branding', { signal }));
export const updateBranding = async (input) => BrandingResponse.parse(await request('/api/v1/organization/branding', {
    method: 'PUT',
    body: input,
}));
/**
 * Sobe a logo.
 *
 * `FormData` sem `Content-Type` escrito à mão: é o objeto que monta a fronteira
 * do multipart, e declarar o cabeçalho quebra o corpo. Mesmo caminho das fotos
 * de produto.
 */
export const uploadBrandingLogo = async (file) => {
    const form = new FormData();
    form.append('file', file);
    return BrandingResponse.parse(await request('/api/v1/organization/branding/logo', {
        method: 'POST',
        body: form,
    }));
};
/**
 * A URL dos bytes, com a versão dentro.
 *
 * A versão é o que faz o navegador buscar de novo depois de uma troca de logo:
 * a resposta é `immutable` com um ano de validade — sem isso, a logo nova só
 * apareceria para quem limpasse o cache.
 */
export const brandingLogoUrl = (version) => `/api/v1/organization/branding/logo?v=${String(version)}`;
//# sourceMappingURL=branding.js.map